import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {NullAsDefault} from 'views/Shared'
import {announcement_gets_Api} from "../../../apis";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import CRUD from "../../Shared/enums/CRUD";
import {formatSimplifyDate} from "../../../helpers/dateUtils";
import _ from "lodash";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import usePaginationHelper, {createPagerKey} from "../../AppLocals/hooks/usePaginationHelper";
import WorkspaceContext from "../WorkspaceContext";
import {useLocation} from "react-use";
import {useRouteSearchParam} from "../../../envs/_current/history";
import {AnnouncementTypes} from "../../AppLocals/Organization/consts/AnnouncementTypes";
import Toggle from "../../../components/Toggle";
import {Button, Image, Modal, Switch} from "antd";
import {isAnnouncementExpired} from "../../AppLocals/Announcement/announcementHelpers";
import {useAnnouncementForm} from "../../AppLocals/Announcement/useAnnouncementForm";
import {FiChevronsRight} from "react-icons/fi";
import {HiLink, HiViewfinderCircle} from "react-icons/hi2";
import {ImagePlaceholder} from "../../../conts/imageBase64";
import classNames from "classnames";
import {TYPE_COLORS} from "../../Organization/components/OrganizationAnnouncementItem";
import {TbEdit, TbTrash} from "react-icons/tb";
import getTitle from "../../../helpers/getTitle";

const WrapperDetailItem = ({title, children}) => {
    const t = useTranslate()

    return (
        <div className="flex flex-col gap-1">
            <span className="font-medium text-color-200 tracking-wide">
                {t(title)}
            </span>
            {children}
        </div>
    )
}

export const renderOrganizationAnnouncement = ({t, handleAction = NullAsDefault, organization = null, actionMenu = false}) => (item) => {

    const {group,type_code, type_label, title, content, photo, time_open, time_close, shared_url, created} = item ?? {}

    const colors = TYPE_COLORS[type_code] || TYPE_COLORS.DEFAULT

    return (
        <Toggle>
            {(isToggle, toggle) => (
                <React.Fragment>
                    <div
                        key={item.id}
                        className="flex flex-col gap-3 shadow-md hover:scale-102 rounded-xl transition-all duration-300">
                        <div className="px-3 py-2 flex flex-col gap-1 border-b">
                            <div className="flex flex-center gap-x-2">
                                {/* Type */}
                                {
                                    !!type_label ? (
                                        <>
                                            {_.find(AnnouncementTypes, {value: item?.type_code || item?.type_label})?.icon}
                                            <span style={{ color: colors?.label }} className="flex-1 font-bold tracking-wider">
                                                {type_label}
                                            </span>
                                        </>
                                    ) : (
                                        <span className="flex-1"/>
                                    )
                                }
                                {/* Action */}
                                {actionMenu && (
                                    <div className="flex items-center gap-x-3">
                                        <div
                                            onClick={() => {
                                                handleAction(CRUD.UPDATE, {...item, organization});
                                            }}
                                            className="font-medium text-xs text-indigo-500 hover:text-primary cursor-pointer transition duration-200">
                                            {t('edit')}
                                        </div>
                                        <div
                                            onClick={() => {
                                                handleAction(CRUD.DELETE, {...item, organization});
                                            }}
                                            className="font-medium text-xs text-red-500 hover:text-primary cursor-pointer transition duration-200">
                                            {t('delete')}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* START: Cấu trúc mới cho Tiêu đề và Nội dung */}
                        <div className="p-3 flex flex-col flex-1">
                            {photo && (
                                <Image
                                    src={photo || ImagePlaceholder}
                                    fallback={ImagePlaceholder}
                                    style={{height: 150}}
                                    className="flex flex-center object-cover rounded-t-xl"
                                    wrapperClassName="w-full object-cover rounded-t-xl rounded-b-3xs"
                                    preview={{
                                        mask: (
                                            <div className="w-full h-full relative">
                                                <HiViewfinderCircle
                                                    size={16} style={{top: 10, right: 10}}
                                                    className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                                />
                                            </div>
                                        ),
                                    }}
                                />
                            )}
                            <div className={classNames(
                                "p-2 flex flex-col background-50 shadow",
                                photo ? 'rounded-b-xl' : 'rounded-xl'
                            )}>
                                <div
                                    onClick={toggle}
                                    className="flex-1 font-bold text-sm text-gray-800 hover:text-primary max-lines-1 cursor-pointer">
                                    {title}
                                </div>
                                <div className="text-xs text-color-300 tracking-wider whitespace-pre-line max-lines-2">
                                    {content}
                                </div>
                                {_.some([time_open, time_close]) && (
                                    <DoubleValueItem
                                        showIcon={true}
                                        labelFirst="time"
                                        valueFirst={formatSimplifyDate(time_open, 'medium')}
                                        labelSecond={time_close && ' - ' || ''}
                                        valueSecond={time_close && formatSimplifyDate(time_close, 'medium')}
                                        className="my-1 text-xs italic"
                                    />
                                )}
                                {!!shared_url && (
                                    <div className="flex items-center gap-1">
                                        <HiLink size={12} className="text-blue-500"/>
                                        <a
                                            href={shared_url} target="_blank" rel="noopener noreferrer"
                                            className="flex-1 text-blue-600 italic no-underline max-lines-1">
                                            {shared_url}
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* Footer */}
                        <div className="p-3 pt-0 flex items-end justify-between gap-2">
                            <div className="flex flex-col flex-1">
                                <span className="font-bold text-secondary-600 tracking-wide">
                                    {group?.title}
                                </span>
                                <p className="text-xs text-color-400 italic">
                                    {t('created on')} {formatSimplifyDate(created, 'fullTime')}
                                </p>
                            </div>
                            <span onClick={toggle}
                                  className="flex items-center gap-1 text-color-400 hover:text-color-100 cursor-pointer">
                                <span className="text-xs italic">
                                    {t('view detail')}
                                </span>
                                <FiChevronsRight size={13}/>
                            </span>
                        </div>
                    </div>
                    {isToggle && (
                        <Modal
                            width={600}
                            footer={null}
                            centered={true}
                            open={isToggle}
                            destroyOnHidden={true}
                            onCancel={() => toggle(false)}>
                            <div className="flex flex-col gap-6">
                                <div className="text-center font-bold text-color-000 tracking-wide">
                                    {t('announcements')}
                                </div>
                                <div className="flex flex-col gap-3">
                                    <WrapperDetailItem title="title">
                                        <span className="ml-3 font-bold text-lg text-gray-700 tracking-wide">
                                            {title}
                                        </span>
                                        {type_label && (
                                            <span
                                                className="ml-3 font-semibold text-sm text-blue-700 italic tracking-wide">
                                                {t(type_label)}
                                            </span>
                                        )}
                                    </WrapperDetailItem>
                                    <WrapperDetailItem title="content">
                                        {photo && (
                                            <Image
                                                src={photo || ImagePlaceholder}
                                                fallback={ImagePlaceholder}
                                                // style={{height: 150}}
                                                className="flex flex-center object-cover rounded-xl"
                                                wrapperClassName="ml-3 w-full object-cover rounded-xl"
                                                preview={{
                                                    mask: (
                                                        <div className="w-full h-full relative">
                                                            <HiViewfinderCircle
                                                                size={16} style={{top: 10, right: 10}}
                                                                className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                                            />
                                                        </div>
                                                    ),
                                                }}
                                            />
                                        )}
                                        <div className="ml-3 text-color-300 tracking-wider whitespace-pre-line">
                                            {content}
                                        </div>
                                        {(time_open || time_close) && (
                                            <DoubleValueItem
                                                showIcon={true}
                                                labelFirst={t('from date')}
                                                valueFirst={formatSimplifyDate(time_open, 'medium')}
                                                labelSecond={t('to date')}
                                                valueSecond={formatSimplifyDate(time_close, 'medium')}
                                                className="ml-3 text-sm"
                                            />
                                        )}
                                        {shared_url && (
                                            <div className="flex items-center gap-1">
                                                <HiLink size={12} className="text-blue-500"/>
                                                <a
                                                    href={shared_url} target="_blank"
                                                    className="flex-1 text-sm text-blue-600 italic no-underline max-lines-1">
                                                    {shared_url}
                                                </a>
                                            </div>
                                        )}
                                    </WrapperDetailItem>
                                    <WrapperDetailItem title="send at">
                                        <span className="ml-3 text-color-300 tracking-wider italic">
                                            {formatSimplifyDate(created, 'fullTime')}
                                        </span>
                                    </WrapperDetailItem>
                                </div>
                                <div className="text-right">
                                    <span
                                        onClick={() => toggle(false)} className="text-color-400 hover:text-color-100 cursor-pointer">
                                        {t('close')}
                                    </span>
                                </div>
                            </div>
                        </Modal>
                    )}
                </React.Fragment>
            )}
        </Toggle>
    )
}

export const renderOrganizationAnnouncementWorkspace = ({translate: t, isLg, handleAction = NullAsDefault, organization = null, actionMenu = false}) => (item) => {

    const {group, course_class, subject, type_code, type_label, title, content, photo, time_open, time_close, shared_url, created} = item ?? {}
    // Item owner_type có thể là 'group' (tab Cộng đoàn) hoặc 'course_class' (tab Khóa học, xem
    // announcement_getsByClassesOwner_Api) - footer hiển thị tên nhóm/lớp tương ứng, ưu tiên tên
    // môn học nếu có (giống cách renderCourseTimetableItem hiển thị ở Lịch sinh hoạt).
    const ownerLabel = group?.title || getTitle(subject) || getTitle(course_class)

    const colors = TYPE_COLORS[type_code] || TYPE_COLORS.DEFAULT
    // Đặt badge "hết hạn" cạnh loại thông báo để phân biệt rõ với các thông báo đang/sắp diễn ra -
    // xem isAnnouncementExpired (không có time_close thì coi như hết hạn cuối ngày time_open).
    const isExpired = isAnnouncementExpired({time_open, time_close, created})

    return (
        <Toggle>
            {(isToggle, toggle) => (
                <React.Fragment>
                    <div key={item.id} className="p-3 md:p-4 flex gap-3 hover:background-100 transition duration-300 custom-item-render relative">
                        {/* Icon */}
                        <div className="flex flex-col gap-6">
                            <div className="mt-1">
                                {_.find(AnnouncementTypes, {value: item?.type_code || item?.type_label})?.icon}
                            </div>
                            {(!isLg && actionMenu) && (
                                <div className="flex flex-col items-center gap-6">
                                    <div
                                        onClick={() => {
                                            handleAction(CRUD.UPDATE, {...item, organization});
                                        }}
                                        className="flex flex-center text-blue-500 hover:text-primary cursor-pointer transition duration-200">
                                        <TbEdit size={16}/>
                                    </div>
                                    <div
                                        onClick={() => {
                                            handleAction(CRUD.DELETE, {...item, organization});
                                        }}
                                        className="flex flex-center text-primary-500 hover:text-primary cursor-pointer transition duration-200">
                                        <TbTrash size={16}/>
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* Content */}
                        <div className="flex flex-col flex-1 relative">
                            <p
                                onClick={toggle}
                                className="inline-block space-x-1">
                                <span className="font-bold text-base text-gray-800 hover:text-primary tracking-wide cursor-pointer">
                                    {title}
                                </span>
                                {!!type_label && (
                                    <span
                                        style={{ padding: '3px 8px', background: colors?.bg, color: colors?.label }}
                                        className="ml-2 w-fit rounded-md font-medium text-2xs italic tracking-wider">
                                        {type_label}
                                    </span>
                                )}
                                {isExpired && (
                                    <span
                                        style={{padding: '3px 8px'}}
                                        className="ml-2 w-fit rounded-md bg-color-100 text-color-400 font-medium text-2xs italic tracking-wider">
                                        {t('expired')}
                                    </span>
                                )}
                            </p>
                            <div className="my-1 text-xs text-color-300 tracking-wider whitespace-pre-line max-lines-2">
                                {content}
                            </div>
                            <div className="flex flex-col md:flex-row gap-x-3 gap-y-1">
                                {_.some([time_open, time_close]) && (
                                    <DoubleValueItem
                                        showIcon={true}
                                        labelFirst="time"
                                        valueFirst={formatSimplifyDate(time_open, 'medium')}
                                        labelSecond={time_close && ' - ' || ''}
                                        valueSecond={time_close && formatSimplifyDate(time_close, 'medium')}
                                        className="text-xs italic tracking-wider"
                                    />
                                )}
                                {!!shared_url && (
                                    <a
                                        href={shared_url} target="_blank" rel="noopener noreferrer"
                                        className="flex-1 text-blue-600 italic no-underline max-lines-1">
                                        {shared_url}
                                    </a>
                                )}
                            </div>
                            {/* Action */}
                            {(isLg && actionMenu) && (
                                <div className={classNames("flex flex-col md:flex-row items-center gap-x-3 contextIcon absolute", isLg && 'top-0 right-0')}>
                                    <div
                                        onClick={() => {
                                            handleAction(CRUD.UPDATE, {...item, organization});
                                        }}
                                        className="font-medium text-xs text-blue-500 hover:text-primary cursor-pointer transition duration-200">
                                        {t('edit')}
                                    </div>
                                    <div
                                        onClick={() => {
                                            handleAction(CRUD.DELETE, {...item, organization});
                                        }}
                                        className="font-medium text-xs text-primary-500 hover:text-primary cursor-pointer transition duration-200">
                                        {t('delete')}
                                    </div>
                                </div>
                            )}
                            {/* Footer */}
                            <div className="my-2 border-b border-color-50"/>
                            <div className="flex items-end justify-between gap-2">
                                <div className="flex flex-col flex-1">
                                    <span className="font-semibold text-slate-600 tracking-wide">
                                        {ownerLabel}
                                    </span>
                                    <p className="text-2xs text-color-400 italic tracking-wider">
                                        {t('created on')} {formatSimplifyDate(created, 'fullTime')}
                                    </p>
                                </div>
                                <span
                                    onClick={toggle}
                                    className="flex items-center gap-1 text-xs text-color-400 hover:text-secondary-600 cursor-pointer">
                                    {t('view detail')} <FiChevronsRight size={13}/>
                                </span>
                            </div>
                        </div>
                    </div>

                    {isToggle && (
                        <Modal
                            width={600}
                            footer={null}
                            centered={true}
                            open={isToggle}
                            destroyOnHidden={true}
                            onCancel={() => toggle(false)}>
                            <div className="flex flex-col gap-6">
                                <div className="text-center font-bold text-color-000 tracking-wide">
                                    {t('announcements')}
                                </div>
                                <div className="flex flex-col gap-3">
                                    <WrapperDetailItem title="title">
                                        <span className="ml-3 font-bold text-lg text-gray-700 tracking-wide">
                                            {title}
                                        </span>
                                        {type_label && (
                                            <span
                                                className="ml-3 font-semibold text-sm text-blue-700 italic tracking-wide">
                                                {t(type_label)}
                                            </span>
                                        )}
                                    </WrapperDetailItem>
                                    <WrapperDetailItem title="content">
                                        {photo && (
                                            <Image
                                                src={photo || ImagePlaceholder}
                                                fallback={ImagePlaceholder}
                                                // style={{height: 150}}
                                                className="flex flex-center object-cover rounded-xl"
                                                wrapperClassName="ml-3 w-full object-cover rounded-xl"
                                                preview={{
                                                    mask: (
                                                        <div className="w-full h-full relative">
                                                            <HiViewfinderCircle
                                                                size={16} style={{top: 10, right: 10}}
                                                                className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                                            />
                                                        </div>
                                                    ),
                                                }}
                                            />
                                        )}
                                        <div className="ml-3 text-color-300 tracking-wider whitespace-pre-line">
                                            {content}
                                        </div>
                                        {(time_open || time_close) && (
                                            <DoubleValueItem
                                                showIcon={true}
                                                labelFirst={t('from date')}
                                                valueFirst={formatSimplifyDate(time_open, 'medium')}
                                                labelSecond={t('to date')}
                                                valueSecond={formatSimplifyDate(time_close, 'medium')}
                                                className="ml-3 text-sm"
                                            />
                                        )}
                                        {shared_url && (
                                            <div className="flex items-center gap-1">
                                                <HiLink size={12} className="text-blue-500"/>
                                                <a
                                                    href={shared_url} target="_blank"
                                                    className="flex-1 text-sm text-blue-600 italic no-underline max-lines-1">
                                                    {shared_url}
                                                </a>
                                            </div>
                                        )}
                                    </WrapperDetailItem>
                                    <WrapperDetailItem title="send at">
                                        <span className="ml-3 text-color-300 tracking-wider italic">
                                            {formatSimplifyDate(created, 'fullTime')}
                                        </span>
                                    </WrapperDetailItem>
                                </div>
                                <div className="text-right">
                                    <span
                                        onClick={() => toggle(false)} className="text-color-400 hover:text-color-100 cursor-pointer">
                                        {t('close')}
                                    </span>
                                </div>
                            </div>
                        </Modal>
                    )}
                </React.Fragment>
            )}
        </Toggle>
    )
}

// Checkbox duy nhất trong panel "bộ lọc nâng cao" (nút phễu có sẵn của usePaginationHelper) - mặc
// định KHÔNG check nên danh sách chỉ lấy thông báo đang/sắp diễn ra, bật lên mới tải thêm nhóm đã
// hết hạn (badge "expired" ở renderOrganizationAnnouncementWorkspace phân biệt rõ 2 nhóm).
export const AnnouncementAdvancedFilter = ({value, onChange = NullAsDefault}) => {
    const t = useTranslate()
    return (
        <div className="flex items-center gap-2 px-1 py-1">
            <Switch
                size="small"
                checked={!!value?.includeExpired}
                onChange={(checked) => onChange({includeExpired: checked ? 1 : undefined})}
            />
            <span className="text-sm text-color-300">{t('include expired announcements')}</span>
        </div>
    )
}

const WorkspaceOrganizationAnnouncements = ({
                                                header = true,
                                                // Ẩn riêng khối title+nút "Tạo mới" trong khi vẫn giữ nguyên search/filter (điều khiển bởi
                                                // `header`/noHeader) - dùng khi trang cha (VD: AnnouncementsTab có tab Cộng đoàn/Khóa học)
                                                // đã tự hiển thị title/mô tả/nút tạo dùng chung ở ngoài, tránh lặp 2 lần.
                                                hideTitleBar = false,
                                                refreshToken,
                                                filter_actions = {
                                                    sortBy: 'sort-by',
                                                    keyword: 'keyword',
                                                    includeExpired: 'include-expired',
                                                },
                                            }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const location = useLocation()
    const {organization} = useContext(WorkspaceContext)
    const groups = _.get(organization, 'groups', [])

    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const includeExpired = useRouteSearchParam(filter_actions.includeExpired)

    const {
        modal,
        refresh_token,
        handleAction = NullAsDefault,
        onRefresh
    } = useAnnouncementForm({
        owner_type: 'organization',
        ownerItem: organization,
        groups,
        notifyListeners: {
            onCreated: (__, data) => {
                onRefresh()
            },
            onUpdated: (__, data) => {
                onRefresh()
            },
            onDeleted: (__, data) => {
                onRefresh()
            },
        }
    });

    const refresh_deps = useMemo(
        () => [
            refresh_token,
            refreshToken,
            organization?.id,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [refresh_token, refreshToken, organization?.id, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        isToggleDefault: false,
        AdvancedFilter: AnnouncementAdvancedFilter,
        query_params: filter_actions,
        withKey: createPagerKey(refresh_deps),
        pagerInfo: {
            RenderEntity: React.Fragment,
            PaginationMeta: NullAsDefault,
            apiInfo: announcement_gets_Api,
            renderItem: renderOrganizationAnnouncementWorkspace({
                isLg: isLg,
                translate: t,
                organization,
                handleAction,
                actionMenu: organization?.available_actions?.organization_manage_announcement === true
            }),
            renderWrap: (child) => (
                <div className={classNames('flex flex-col divide-y divide-gray-100', header && 'mt-3 list-item-workspace')}>
                    {child}
                </div>
            )
        },
        // owner_type/owner_id cố định. Lọc/sắp xếp mặc định "chỉ đang-sắp diễn ra, sắp xếp theo
        // time_open tăng dần" + search/filter toggle chỉ bật khi header=true (đúng màn quản lý
        // Workspace > Truyền thông > Thông báo) - KHÔNG áp cho widget preview "newest announcements"
        // nhúng compact ở WorkspaceInsights (header=false), giữ nguyên hành vi cũ ở đó.
        // Dùng withValues (không set pagerInfo.values) để giữ lại keyword/filterBy usePaginationHelper
        // tự tính - set thẳng values sẽ ghi đè mất, làm search/filter không tới được API.
        withValues: ({includeExpired, ...values}) => ({
            ...values,
            owner_type: 'organization',
            owner_id: organization?.id,
            ...(header ? {
                sort_by: 'time_open_asc',
                status: includeExpired ? undefined : 1,
            } : {}),
        }),
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({
                includeExpired: includeExpired === '1' ? 1 : undefined,
            })
        },
        filter_params: {},
        dependencies: [],
        noHeader: !header,
    })

    return (
        <div className="antialiased flex flex-col gap-3">
            {header && !hideTitleBar && (
                <div className="flex flex-col md:flex-row md:items-center gap-3">
                    <div className="flex flex-col flex-1">
                        <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                            {t('announcements')}
                        </h2>
                        <div className="mt-1 w-20 h-1 rounded-full bg-gray-400"/>
                    </div>
                    <Button
                        color="primary" variant="solid"
                        className="rounded-lg no-border flex flex-center font-semibold"
                        onClick={() => {
                            handleAction(CRUD.CREATE);
                        }}>
                        {t('create')}
                    </Button>
                </div>
            )}
            {pager_widget}
            {modal}
            <div className="h-16"/>
        </div>
    )
}

export default WorkspaceOrganizationAnnouncements
